// The data-entry rows (Enter hours, Enter numbers, Import CSV): the KPIs sidebar's DATA ENTRY footer
// (design spec 2026-10-19 §4). Managers only; numbers only while `kpi` is on. Setup › Data shows
// hours and import too, but only while KPIs › Scorecard cannot be opened (`kpi` off), so they are never
// listed twice.
import { NavList, NavRow } from "@companyos/ui";
import { Link } from "@tanstack/react-router";
import { ClockIcon, HashIcon, UploadIcon } from "lucide-react";
import { type CompanyAccess, isManager } from "../../features/company";
import { useFeature } from "../../features/use-feature";
import { keepFocus } from "../../focus/focus";

export function ManagerDataRows({ company }: { company: CompanyAccess }) {
  const kpi = useFeature("kpi");
  if (!isManager(company)) return null;
  const params = { slug: company.slug };
  const active = { includeSearch: false } as const;
  return (
    <NavList>
      <NavRow
        icon={ClockIcon}
        label="Enter hours"
        render={
          <Link
            to="/c/$slug/kpis/entry/hours"
            params={params}
            search={keepFocus}
            activeOptions={active}
          />
        }
      />
      {kpi.enabled ? (
        <NavRow
          icon={HashIcon}
          label="Enter numbers"
          render={
            <Link
              to="/c/$slug/kpis/entry/numbers"
              params={params}
              search={keepFocus}
              activeOptions={active}
            />
          }
        />
      ) : null}
      <NavRow
        icon={UploadIcon}
        label="Import CSV"
        render={
          <Link
            to="/c/$slug/kpis/import"
            params={params}
            search={keepFocus}
            activeOptions={active}
          />
        }
      />
    </NavList>
  );
}
